import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Home, Briefcase, User, Mail } from 'lucide-react';

const BottomNav = () => {
  const location = useLocation();
  const [isVisible, setIsVisible] = useState(true);
  const [lastScrollY, setLastScrollY] = useState(0);

  // Hide on scroll down, show on scroll up
  useEffect(() => {
    const handleScroll = () => {
      const currentScrollY = window.scrollY;
      
      if (currentScrollY > lastScrollY && currentScrollY > 100) {
        setIsVisible(false);
      } else {
        setIsVisible(true);
      }
      
      setLastScrollY(currentScrollY);
    };

    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, [lastScrollY]);

  const navItems = [
    { icon: Home, label: 'Home', path: '/', isRoute: true },
    { icon: Briefcase, label: 'Ventures', path: '/#ventures', isRoute: false },
    { icon: User, label: 'About', path: '/about', isRoute: true },
    { icon: Mail, label: 'Contact', path: '/#contact', isRoute: false },
  ];

  const isActive = (item) => {
    if (item.isRoute) {
      return location.pathname === item.path;
    }
    return false;
  };

  return (
    <nav 
      className={`fixed bottom-0 left-0 right-0 z-50 md:hidden transition-transform duration-300 ${
        isVisible ? 'translate-y-0' : 'translate-y-full'
      }`}
      data-testid="bottom-nav"
    >
      {/* Gradient fade above nav */}
      <div className="absolute -top-6 left-0 right-0 h-6 bg-gradient-to-t from-white to-transparent pointer-events-none"></div>
      
      {/* Nav container */}
      <div className="bg-white/95 backdrop-blur-xl border-t border-slate-200 px-2 pb-safe">
        <div className="flex items-center justify-around py-2">
          {navItems.map((item) => {
            const Icon = item.icon;
            const active = isActive(item);
            
            if (item.isRoute) {
              return (
                <Link
                  key={item.label}
                  to={item.path}
                  data-testid={`bottom-nav-${item.label.toLowerCase()}`}
                  className={`flex flex-col items-center justify-center py-2 px-4 rounded-xl transition-all duration-200 ${
                    active 
                      ? 'text-slate-900 bg-slate-100' 
                      : 'text-slate-500 hover:text-slate-700 hover:bg-slate-50'
                  }`}
                >
                  <Icon className={`w-5 h-5 mb-1 transition-transform duration-200 ${active ? 'scale-110' : ''}`} />
                  <span className="text-xs font-medium">{item.label}</span>
                  {active && (
                    <div className="absolute -bottom-0.5 w-1 h-1 rounded-full bg-slate-900"></div>
                  )}
                </Link>
              );
            }
            
            return (
              <a
                key={item.label}
                href={item.path}
                data-testid={`bottom-nav-${item.label.toLowerCase()}`}
                className="flex flex-col items-center justify-center py-2 px-4 rounded-xl transition-all duration-200 text-slate-500 hover:text-slate-700 hover:bg-slate-50"
              >
                <Icon className="w-5 h-5 mb-1" />
                <span className="text-xs font-medium">{item.label}</span>
              </a>
            );
          })}
        </div>
      </div>
    </nav>
  );
};

export default BottomNav;
